import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface FAQItem {
  question: string;
  answer: string;
}
const faqs: FAQItem[] = [{
  question: '¿En qué formato recibo el material?',
  answer: 'Recibirás todo el contenido en formato PDF digital, fácil de leer en cualquier dispositivo. Los audios de relajación están en formato MP3 para que puedas escucharlos cuando quieras.'
}, {
  question: '¿Cuánto tarda en llegar el contenido después de la compra?',
  answer: 'El acceso es inmediato. Una vez confirmado el pago, recibirás un email con todos los enlaces de descarga. Podrás empezar a leer y escuchar en menos de 5 minutos.'
}, {
  question: '¿Tengo acceso para siempre al material?',
  answer: 'Sí, completamente. Una vez que descargas el material, es tuyo para siempre. Puedes guardarlo, releerlo y volver a él cuando lo necesites, sin límite de tiempo.'
}, {
  question: '¿Puedo acceder desde cualquier país?',
  answer: 'Sí, el contenido es 100% digital y accesible desde cualquier parte del mundo. Solo necesitas conexión a internet para descargarlo la primera vez.'
}, {
  question: '¿Puedo imprimir el ebook?',
  answer: 'Por supuesto. El PDF está diseñado para que puedas imprimirlo si prefieres leer en papel. Muchas mujeres lo hacen para tenerlo siempre a mano.'
}, {
  question: '¿El contenido es largo o difícil de leer?',
  answer: 'No. Está diseñado para ser claro, directo y aplicable. No es un libro académico ni complicado. Es una guía práctica que puedes leer en pequeños momentos, sin presión.'
}, {
  question: '¿Este ebook reemplaza un tratamiento profesional?',
  answer: 'No. Este material es una herramienta de apoyo y autocuidado, pero no reemplaza el acompañamiento de un profesional de la salud mental si lo necesitas. Es un complemento valioso para tu bienestar.'
}, {
  question: '¿Es un pago único?',
  answer: 'Sí, es un pago único. No hay suscripciones ni cargos recurrentes. Pagas una sola vez y el material es tuyo para siempre.'
}, {
  question: '¿Cómo funciona la garantía de 7 días?',
  answer: 'Si por cualquier motivo sientes que el contenido no es lo que esperabas, tienes 7 días para solicitar la devolución completa de tu dinero. Sin preguntas incómodas, sin complicaciones.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-16 px-4 bg-gradient-to-b from-white to-blue-50/30" data-id="element-5">
      <div className="max-w-3xl mx-auto" data-id="element-6">
        {/* Header */}
        <div className="text-center mb-12" data-id="element-7">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-700 mb-3" data-id="element-8">
            Resolve aquí tus dudas
          </h2>
          <p className="text-lg text-gray-500" data-id="element-9">
            Hacé clic para ver la respuesta que necesitás
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-4" data-id="element-10">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-md transition-shadow" data-id="element-11">
              <button onClick={() => toggleFAQ(index)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-50/50 transition-colors" data-id="element-12">
                <span className="font-semibold text-gray-700 pr-4" data-id="element-13">
                  {faq.question}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.3
            }} className="flex-shrink-0" data-id="element-14">
                  <ChevronDown className="w-5 h-5 text-gray-400" data-id="element-15" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-16">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-17">
                    <div className="px-6 pb-5 text-gray-600 leading-relaxed" data-id="element-18">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>

        {/* Bottom CTA */}
        <div className="mt-12 text-center" data-id="element-19">
          <p className="text-gray-500 mb-4" data-id="element-20">¿Todavía tenés dudas?</p>
          <p className="text-sm text-gray-400" data-id="element-21">
            Recordá que tenés 7 días de garantía para probar el contenido sin
            riesgo.
          </p>
        </div>
      </div>
    </section>;
}